var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-height-flag" },
    [
      _vm.isHeader
        ? _c("el-card", { staticClass: "mb14" }, [
            _vm.isHeader
              ? _c("div", { staticClass: "flex-box" }, [
                  _c("div", { staticClass: "header" }, [
                    _c("div", { staticClass: "left" }, [
                      _c("i", {
                        staticClass: "el-icon-arrow-left",
                        on: { click: _vm.clickReturn },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "invoice-logo" }, [
                        _c("i", {
                          staticClass: "icon iconfont iconchuanjainkaohe",
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.rowData &&
                              _vm.rowData.test &&
                              _vm.rowData.test.name
                              ? _vm.rowData.test.name + "的考核"
                              : "绩效考核"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "process-left-list" },
                        _vm._l(_vm.tableData, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "process-list" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "text",
                                  class:
                                    index == _vm.processIndex ? "active" : "",
                                  attrs: { round: "" },
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _vm._v(" "),
                              index != _vm.tableData.length - 1
                                ? _c("i", {
                                    staticClass: "el-icon-arrow-right",
                                  })
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "process-right" },
                    [
                      _vm.isShow && _vm.strType !== "check"
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.onlySaveSubmit },
                            },
                            [_vm._v("仅保存")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShow && _vm.strType !== "check"
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.addSaveSubmit },
                            },
                            [_vm._v(_vm._s(_vm.isShowButton))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-card",
        { attrs: { "body-style": { padding: "0 20px 20px 20px" } } },
        [
          _vm.isTips
            ? _c("div", [
                _vm.processIndex == 3
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.appeal.user_id != undefined &&
                              _vm.assessInfo.verify &&
                              _vm.assessInfo.verify.id == _vm.userId,
                            expression:
                              "appeal.user_id != undefined && assessInfo.verify && assessInfo.verify.id == userId",
                          },
                        ],
                        staticClass: "tips-box mb15 tActive",
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-close",
                          on: { click: _vm.closeTips },
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("绩效申诉: " + _vm._s(_vm.appeal.content)),
                        ]),
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "mb14" },
                      [
                        _vm.tipsBoxContent
                          ? _c(
                              "el-alert",
                              {
                                staticClass: "cr-alert",
                                attrs: {
                                  title: "",
                                  closable: true,
                                  type: "info",
                                  "show-icon": false,
                                },
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _c("p", [_vm._v(_vm._s(_vm.tipsBoxContent))]),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.processIndex == 0 || _vm.processIndex == 5
            ? _c("goalSetting", {
                ref: "goalSetting",
                attrs: {
                  id: _vm.id,
                  rowData: _vm.rowData,
                  strType: _vm.strType,
                  "add-button": _vm.addButton,
                },
                on: { handleGoal: _vm.handleGoal },
              })
            : _vm._e(),
          _vm._v(" "),
          [1, 2, 3, 4].includes(_vm.processIndex)
            ? _c("execution", {
                ref: "execution",
                attrs: {
                  id: _vm.id,
                  strType: _vm.strType,
                  reply: _vm.reply,
                  isShow: _vm.isShowProps,
                  processIndex: _vm.processIndex,
                  appeal: _vm.appeal,
                  marks: _vm.mark,
                },
                on: {
                  saveOk: _vm.saveOk,
                  handleExecution: _vm.handleExecution,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }